import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appHideCollapse]',
  standalone: true,
})
export class HideCollapseDirective {
  @Input() containerRef!: HTMLElement;
  @Input() transitionTiming: string = '0.25s cubic-bezier(0.42, 0, 0.58, 1)';

  constructor(private el: ElementRef) {}

  @HostListener('click')
  handleClick() {
    this.collapseSection();
  }

  @HostListener('keydown.enter')
  handleKeyPress() {
    this.collapseSection();
  }

  private collapseSection() {
    if (!this.containerRef) return;

    const sectionHeight = this.containerRef.scrollHeight;

    this.containerRef.style.transition = '';
    this.containerRef.inert = true;
    this.containerRef.ariaHidden = 'true';

    requestAnimationFrame(() => {
      this.containerRef.style.height = sectionHeight + 'px';
      this.containerRef.style.overflow = 'hidden';
      this.containerRef.style.transition = `height ${this.transitionTiming}`;

      requestAnimationFrame(() => {
        this.containerRef.style.height = '0px';
      });
    });
  }
}
